import React, { useState, useEffect } from 'react';
import leaderImage from '../img/envision/aerospace/Jyotheeswara Reddy.jpg';  // Import the image file
import BoardOfDirectorsnavbar from './BoardOfDirectorsnavbar';
import { FaLinkedin } from 'react-icons/fa';
import AboutLeadershipsecondcontainer from './AboutLeadershipsecondcontainer';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';
const Leadersjyoheswarreddy = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [location]); // Run effect when the route changes

    return (
        <div>
            <div style={{ background: "rgb(236 115 34)", marginTop: "80px", height: "63px" }}>
                <h1 style={{ textAlign: "center", paddingTop: "13px" }}>OUR LEADERSHIP</h1>
            </div>
            {/* <BoardOfDirectorsnavbar />    */}
            <div style={styles.rowWrapper}>

                <div style={styles.row}>
                    <div style={styles.widgetSpan}>
                        <div id="hs_cos_wrapper_module_1564397675620228" style={styles.hsCosWrapper}>
                            {/* LazySizes Script */}
                            <script src="https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js" async=""></script>

                            <div style={styles.abMembers}>
                                <div style={styles.container}>
                                    <div style={styles.imageColumn}>
                                        <div style={styles.mImage}>
                                            {/* Use the imported image */}
                                            <img
                                                className="ls-is-cached lazyloaded"
                                                src={leaderImage}  // Use the imported image here
                                                alt="Naga Mohan Gollangi"
                                                style={styles.image}
                                            />
                                        </div>
                                    </div>
                                    <div style={styles.textColumn}>
                                        <h1>Dr. Jyotheeswara Reddy Edula </h1>
                                        <span>Advisory Board Member – Pharma & Healthcare</span>
                                        <br />

                                        {/* LinkedIn Icon */}
                                        <a href="https://www.linkedin.com/in/bhaskar-reddy-8b630a71/" target="_blank" rel="noopener noreferrer">
                                            <FaLinkedin size={30} color="#0077B5" />
                                        </a>

                                    </div>
                                </div>
                            </div>

                            <div style={styles.memberParagraph}>
                                <div style={styles.container}>
                                    <div style={styles.col12}>
                                        <div style={styles.teamParagraph}>
                                            <p style={{ textAlign: 'justify', fontWeight: 'bold', fontSize: '20px' }}>Dr. Jyotheeswara Reddy Edula –Advisory Board Member – Pharma & Healthcare, DREBCON  </p>

                                            <p style={{ textAlign: 'justify', marginTop: '10px' }}>
                                                Dr. Jyotheeswara Reddy Edula is a globally recognized leader in the biotech and healthcare domain, with over 20 years of expertise spanning drug discovery, product development, recombinant therapeutics, monoclonal antibodies (mAbs), vaccines, biosimilars, and global healthcare collaborations. He brings deep scientific expertise and business acumen to guide innovation, regulatory excellence, and market expansion for DREBCON's Pharma & Healthcare initiatives.</p>

                                            <br></br>
                                            <p style={{ textAlign: 'justify', fontWeight: 'bold', fontSize: '20px', }}>Leadership & Professional Experience:</p>


                                            <ul style={{ textAlign: 'justify', marginTop: '10px' }}>

                                                <li style={{ marginLeft: "30px", fontWeight: "bold" }}>Dr. Reddy has held pivotal research and leadership positions at several world-renowned academic and research institutions, including:</li>
                                                <li style={{ marginLeft: "30px" }}>	Tata Institute for Genetics and Society, India</li>
                                                <li style={{ marginLeft: "30px" }}>	University of California, San Diego, USA</li>
                                                <li style={{ marginLeft: "30px" }}>Research Institute for Microbial Diseases, Osaka University, Japan</li>
                                                <li style={{ marginLeft: "30px" }}>RIKEN, Japan</li>
                                                <li style={{ marginLeft: "30px" }}>ICGEB, India</li>
                                                <li style={{ marginLeft: "30px" }}>In his current role as Executive Director of Indus Gene Expressions Ltd. (India & USA), Dr. Reddy spearheads strategic R&D programs, global partnerships, and commercialization of innovative therapeutics across USA, India, LATAM, Turkey, Middle East, and beyond.</li>
                                            </ul>


                                            <p style={{ textAlign: 'justify', marginTop: '10px', fontWeight: 'bold' }}>
                                                Industrial Affiliations & Collaborations
                                            </p>

                                            <ul style={{ textAlign: 'justify', marginTop: '10px' }}>

                                                <li style={{ marginLeft: "30px" }}>Dr. Reddy has successfully led technology transfer and process development collaborations with leading global life sciences organizations, including:</li>
                                                <li style={{ marginLeft: "30px" }}>	Verily Life Sciences LLC, USA</li>
                                                <li style={{ marginLeft: "30px" }}>	BIKEN Co., Ltd, Japan</li>
                                                <li style={{ marginLeft: "30px" }}>Nobelpharma, Japan</li>
                                                <li style={{ marginLeft: "30px" }}>	Bharat Biotech, India</li>
                                                <li style={{ marginLeft: "30px" }}>	Syngene International, India</li>
                                                <li style={{ marginLeft: "30px" }}>		Zydus Lifesciences, India</li>



                                            </ul>




                                            <ul style={{ textAlign: 'justify', marginTop: '10px' }}>

                                                <li style={{ marginLeft: "30px" }}>Academic Credentials</li>
                                                <li style={{ marginLeft: "30px" }}>	Ph.D. in Biotechnology, JNTU & CCMB, India</li>
                                                <li style={{ marginLeft: "30px" }}>Postgraduate Diploma in Patent Law, NALSAR University of Law, India</li>
                                                <li style={{ marginLeft: "30px" }}>M.Sc. in Biotechnology, Bangalore University, India</li>
                                                <li style={{ marginLeft: "30px" }}>B.Sc. in Medical Laboratory Technology, SV University, India</li>




                                            </ul>



                                            <p style={{ textAlign: 'justify', fontWeight: 'bold', marginTop: '20px' }}>
                                               Research Grants & Awards
                                            </p>

                                            <ul style={{ textAlign: 'justify', marginTop: '10px' }}>

                                                <li style={{ marginLeft: "30px", fontWeight:"bold" }}>Dr. Reddy's groundbreaking contributions to life sciences have been recognized through prestigious national and international grants and awards, including:</li>
                                                <li style={{ marginLeft: "30px" }}>JSPS Grant for Early-Career Scientists, Japan</li>
                                                <li style={{ marginLeft: "30px" }}>	GHIT (Global Health Innovative Technology) Grant, Japan</li>

                                                <li style={{ marginLeft: "30px" }}>IAVI (International AIDS Vaccine Initiative) Grant, India</li>
                                                <li style={{ marginLeft: "30px" }}>DBT (Department of Biotechnology) Grant, India</li>
                                                <li style={{ marginLeft: "30px" }}>Research Excellence Award, India</li>

                                                <li style={{ marginLeft: "30px" }}>Zonal & National Awards, India</li>

                                                <li style={{ marginLeft: "30px" }}>Consecutive Taniguchi Memorial Awards (2015–2018), Japan</li>


                                            </ul>


                                            <p style={{ textAlign: 'justify', marginTop: '10px', fontWeight: 'bold', }}>
                                             Publications
                                            </p>
                                            <ul style={{ textAlign: 'justify', marginTop: '10px' }}>

                                                <li style={{ marginLeft: "30px", fontWeight:"bold" }}>Dr. Reddy has authored over 17 peer-reviewed articles and a book chapter, with his research featured in globally acclaimed journals. Select publications include:</li>
                                                <li style={{ marginLeft: "30px" }}>Suppressing mosquito populations with precision-guided sterile males, Nature Communications, 2021</li>
                                                <li style={{ marginLeft: "30px" }}>Hexane Extract of Raphanus sativus L. Roots Inhibits Cell Proliferation and Induces Apoptosis in Human Cancer Cells, BMC Complementary Medicine and Therapies, 2020</li>

                                                <li style={{ marginLeft: "30px" }}>Identification of a potent combination of key Plasmodium falciparum merozoite antigens that elicit strain-transcending neutralizing antibodies, Infection and Immunity, 2018</li>
                                                <li style={{ marginLeft: "30px" }}>Winding the way forward: between effector gene design and pathogen evolution in vector population replacement strategies, Philosophical Transactions of the Royal Society B, 2018</li>
                                                <li style={{ marginLeft: "30px" }}>Molecular Camouflage of Plasmodium falciparum Merozoites by Binding of Host Vitronectin, PLOS Pathogens, 2017</li>

                                                <li style={{ marginLeft: "30px" }}>Molecular Camouflage of Plasmodium falciparum Merozoites by Binding of Host Vitronectin, PLOS Pathogens, 2017</li>

                                                <li style={{ marginLeft: "30px" }}>First-in-human randomized trial and follow-up study of Plasmodium falciparum blood-stage vaccine candidate (PfF2) with CPG-ODN, Vaccine, 2016</li>
                                                <li style={{ marginLeft: "30px" }}>Mechanistic and structural basis of bioengineered bovine Cathelicidin-5 with optimized therapeutic activity, Scientific Reports, 2018</li>

   <li style={{ marginLeft: "30px" }}>Strategies for Enhancing Product Yield: Design of Experiments, Formulation Science, 2016</li>
                                                <li style={{ marginLeft: "30px" }}>	Emerging bioethanol production from agro crop residues in Andhra Pradesh state: a case study, Renewable and Sustainable Energy Reviews, 2021</li>


                                            </ul>

                                            <ul style={{ textAlign: 'justify', marginTop: '10px' }}>

                                                <li style={{ marginLeft: "30px", fontWeight:"bold" }}>Global Engagements</li>
                                                <li style={{ marginLeft: "30px" }}>Dr. Reddy's scientific leadership is widely recognized, with invited talks, research collaborations, and international engagements across the USA, Japan, Italy, Brazil, Thailand, Singapore, Malaysia, and China.</li>
                                                <li style={{ marginLeft: "30px", fontWeight:"bold" }}>Key Contributions to Pharma & Healthcare</li>

                                                <li style={{ marginLeft: "30px" }}>With his unique blend of scientific excellence, global experience, and business leadership, Dr. Jyotheeswara Reddy Edula provides invaluable advisory support to DREBCON's Pharma & Healthcare vertical, guiding cutting-edge innovation, regulatory frameworks, and industry collaborations that advance global healthcare outcomes.</li>
                                              


                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <style>
                    {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
                </style>
            </div>
            <AboutLeadershipsecondcontainer />
            <Footer />
        </div>
    );
};

const styles = {
    rowWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 0',
        marginTop: '46px',
    },
    row: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '1200px',
    },
    widgetSpan: {
        padding: '20px',
    },
    hsCosWrapper: {
        marginBottom: '30px',
    },
    abMembers: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '20px',
    },
    container: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
    },
    imageColumn: {
        flex: 1,
        paddingRight: '20px',
    },
    mImage: {
        width: '100%',
    },
    image: {
        width: '86%',
        borderRadius: '8px',
        border: '1px solid'
    },
    textColumn: {
        flex: 2,
        paddingLeft: '20px',
        display: 'flex',               // Add display flex to enable flexbox layout
        flexDirection: 'column',       // Arrange children in a column
        justifyContent: 'center',     // Vertically center the content
        // alignItems: 'center',         
        // textAlign: 'center',       
    },
    socialLink: {
        display: 'inline-block',
        marginTop: '10px',
    },
    socialIcon: {
        width: '30px',
        height: '30px',
    },
    memberParagraph: {
        padding: '20px',
    },
    col12: {
        width: '100%',
    },
    teamParagraph: {
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#333',
        textAlign: 'justify',  // Added text alignment as justify
    },
};

export default Leadersjyoheswarreddy;
